import api from './api';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface User {
  id: number;
  username: string;
  email: string;
  profile_picture?: string | null;
  full_name: string;
  designation?: string | null;
  role: 'admin' | 'manager' | 'technician' | 'viewer' | 'machine';
  assigned_machine?: string;
  allowed_systems?: string[];
}

export interface LoginResponse {
  message: string;
  token: string;
  user: User;
}

export const authService = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  getProfile: async (): Promise<{ user: User }> => {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  updateProfile: async (data: { full_name: string; email: string; designation?: string }): Promise<{ user: User }> => {
    const response = await api.put('/auth/profile', data);
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string) => {
    const response = await api.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return response.data;
  },

  uploadProfilePicture: async (file: File): Promise<{ user: User }> => {
    const formData = new FormData();
    formData.append('picture', file);
    // Delete the default Content-Type so axios auto-sets multipart/form-data with the correct boundary
    const response = await api.post('/auth/profile/picture', formData, {
      headers: { 'Content-Type': undefined },
    });
    return response.data;
  },

  deleteProfilePicture: async (): Promise<{ user: User }> => {
    const response = await api.delete('/auth/profile/picture');
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
};
